(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/routes.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/routes.js');
"use strict";


setGlobal('svs.ticketsValidate.routes', {
  ROOT: '/',
  LANDING: '/:ticketId',
  VALIDATE: '/:ticketId/kontrollera',
  VALIDATED: '/:ticketId/kontrollera/:code',
  VALIDATED_BUY_NEW: '/:ticketId/kontrollera/:code/kop-nya',
  VALIDATED_BUY_NEW_DEFAULT: '/kop-nya'
});

 })(window);